export const SV_headings = {
    overView: "Översikt",
    companyInformation: "Information om kontaktföretaget",
    personInformation: "Information om kontaktpersonen",
    compareCompanies: "Jämför kontaktföretag",
    comparePersons: "Jämför kontakpersoner",
    matchingEntities: "Matchade kontaktföretag och kontakpersoner",
    createPerson: "Skapa ny kontaktperson",
    createCompany: "Skapa nytt kontaktföretag",
    createActivity: "Skapa ny aktivitet",
    editCompany: "Redigera kontakföretag",
    editPerson: "Redigera kontaktperson",
    editActivity: "Redigera aktivitet", 
    contactCompanies: "Kontaktföretag",
    contactPersons: "Kontaktpersoner",
    activities: "Aktiviteter"
}

export const EN_headings = {
    overView: "Overview",
    companyInformation: "Contact company information",
    personInformation: "Contact person information",
    compareCompanies: "Compare contact companies",
    comparePersons: "Compare contact persons",
    matchingEntities: "Matching contact companies and contact persons",
    createPerson: "New contact person",
    createCompany: "New contact company",
    createActivity: "New activity",
    editCompany: "Edit contact company",
    editPerson: "Edit contact person",
    editActivity: "Edit activity", 
    contactCompanies: "Contact companies",
    contactPersons: "Contact persons",
    activities: "Activities"
}